import {
  TAXONOMY_SKIP_SEGMENT,
  taxonomyAttributeToFacetKey,
} from 'src/adapters/pageURLToStore/taxonomyPath';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

export const deriveTaxonomyLevelsFromFacets = (
  facets: Facet[],
  taxonomyAttributes: TaxonomyAttribute[],
): string[] => {
  if (taxonomyAttributes.length === 0) {
    return [];
  }

  const facetByKey = new Map(facets.map((facet) => [facet.key, facet]));

  const slots: string[] = taxonomyAttributes.map(({ attributeKey }) => {
    const facet = facetByKey.get(taxonomyAttributeToFacetKey(attributeKey));
    const activeOptions = facet?.options.filter((option) => option.active) ?? [];
    return activeOptions.length > 0
      ? activeOptions
          .map((o) => o.value)
          .sort()
          .join(',')
      : TAXONOMY_SKIP_SEGMENT;
  });

  while (slots.length > 0 && slots[slots.length - 1] === TAXONOMY_SKIP_SEGMENT) {
    slots.pop();
  }

  return slots;
};
